import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { X, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-black px-4">
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-xl border border-white/20 bg-[#050505] p-10 text-center md:p-16"
        data-testid="payment-cancel-page"
      >
        <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center border border-white/40">
          <X className="h-8 w-8 text-white" strokeWidth={2} />
        </div>
        <p className="label-caps mb-4">Donation Cancelled</p>
        <h1 className="font-oswald text-4xl font-bold uppercase leading-none tracking-tighter text-white md:text-5xl">
          No worries
        </h1>
        <p className="mt-6 text-white/80">
          Your payment was cancelled and you haven't been charged. Whenever you're ready, your
          plaque on the Ball Wall is waiting.
        </p>
        <button
          data-testid="cancel-back-btn"
          onClick={() => navigate("/ballwall")}
          className="mt-10 inline-flex items-center gap-2 border border-white/25 px-6 py-3 font-oswald text-xs uppercase tracking-[0.2em] text-white transition-colors hover:bg-white hover:text-black"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Campaign
        </button>
      </motion.div>
    </div>
  );
}
